import React from 'react'
import { useNavigate } from 'react-router-dom'

/**
 * ShareCTA Component
 *
 * Encourages the senior to share a story when inbox is empty or low.
 * Uses olive styling (not action-required terra-cotta).
 */
function ShareCTA({ onShareStory }) {
  const navigate = useNavigate()

  const handleShare = () => {
    if (onShareStory) {
      onShareStory()
    } else {
      navigate('/create-story')
    }
  }

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6">
      <div className="flex items-center gap-4">
        {/* Icon */}
        <div className="w-16 h-16 rounded-full bg-fb-cream flex items-center justify-center flex-shrink-0">
          <span className="text-3xl">✍️</span>
        </div>

        {/* Content */}
        <div className="flex-1">
          <h3 className="font-serif font-bold text-gray-900 text-lg mb-1">
            Share Something New
          </h3>
          <p className="font-serif text-gray-600 text-base">
            Your family loves hearing from you. Share a memory, photo, or life lesson.
          </p>
        </div>

        {/* Action Button */}
        <button
          onClick={handleShare}
          className="bg-fb-olive hover:bg-fb-olive/90 text-white font-bold py-3 px-6 rounded-lg text-base transition-colors min-h-[48px] flex-shrink-0"
        >
          Share a Story
        </button>
      </div>
    </div>
  )
}

export default ShareCTA
